
import React, { Component } from 'react';
import './App.css';



// This will be used to show top info 
// Name, Address, Phone, Email.


class Education extends Component {
   render() { 
     return (
	 <div className="Education">
	 {this.props.children}
	 </div>
     );
   }
}

export default Education;



// WEBPACK FOOTER //
// ./src/Education.js